import Login from '../components/authentication/login';
// import NetworkLogger from '../components/testComponents/NetworkLogger';

import '../styles/login.css';

const LoginPage = () => {
  return (
    <div>
      <div className="login-page">
        <Login />
        <img src="/login-side.png" className="login-image" alt="pp" />
      </div>
    </div>
  );

};

export default LoginPage;